import { LINKS } from "@/data/site";
import { MessageCircle, Send } from "lucide-react";

export default function FloatingContact() {
  return (
    <div
      data-testid="floating-contact"
      className="fixed left-4 bottom-6 z-40 flex flex-col gap-3"
    >
      <a
        href={LINKS.whatsappLink}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        aria-label="WhatsApp"
        className="pulse-ring w-12 h-12 rounded-full bg-emerald-500 text-white flex items-center justify-center shadow-xl hover:scale-110 transition"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={LINKS.telegram}
        target="_blank"
        rel="noreferrer"
        data-testid="float-telegram"
        aria-label="Telegram"
        className="pulse-ring w-12 h-12 rounded-full bg-sky-500 text-white flex items-center justify-center shadow-xl hover:scale-110 transition"
      >
        <Send className="w-6 h-6" />
      </a>
    </div>
  );
}
